'use client';

import { useEffect, useState } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { bindBrowserQueryClient, createQueryClient } from './query-client';
import { QueryClientProvider } from './tanstack-reexports';
interface QueryProviderProps {
  children: React.ReactNode;
}
export function QueryProvider({
  children
}: QueryProviderProps) {
  const [queryClient] = useState(() => createQueryClient());

  // Auth-loss redirects clear via getQueryClient(); bind the
  // provider instance so that hits the live React Query cache.
  useEffect(() => {
    bindBrowserQueryClient(queryClient);
  }, [queryClient]);

  // Devtools only in development
  const devtools = process.env.NODE_ENV === 'development' ? <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" /> : null;
  return <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="QueryProvider" data-sentry-source-file="query-provider.tsx">
      {children}
      {devtools}
    </QueryClientProvider>;
}